<template>
<!-- 个人中心联系我们页面 -->
  <div id="sd-concat-us">
    <!-- title -->
    <div class="top-title">
      <img src="../../assets/img/login-img/3-1档案-返回ic@2x.png" alt="" class="back-icon" @click="goBack">
      <p class="title-text siyuan-bold">联系我们</p>
    </div>
    <!-- end -->
    <!-- 阴影 -->
    <!-- <div class="shadow">
    </div> -->
    <!-- end -->
    <div class="content-box">
      <div class="concat-logo">
        <img  src="../../assets/img/login-img/5-联系我们@2x.png" alt="" class="logo-img">
      </div>
      <ul class="concat-list">
        <li class="list-item list-flag">
          <div class="item-left">
            <p class="left-text">【深读】公众号</p>
          </div>
          <div class="item-right">
            <p class="right-text"> shendutv</p>
            <img v-if="false" src="../../assets/img/login-img/1-注册-下一步ic@2x.png" alt="" class="more-icon">
          </div>
        </li>
        <li class="list-item">
          <div class="item-left">
            <p class="left-text">【深读】微博</p>
          </div>
          <div class="item-right">
            <p class="right-text">深读官方微博</p>
            <img v-if="false" src="../../assets/img/login-img/1-注册-下一步ic@2x.png" alt="" class="more-icon">
          </div>
        </li>
        <li class="list-item">
          <div class="item-left">
            <p class="left-text">&nbsp;&nbsp;微信客服</p>
          </div>
          <div class="item-right">
            <p class="right-text">shendu-tv1</p>
            <img v-if="false" src="../../assets/img/login-img/1-注册-下一步ic@2x.png" alt="" class="more-icon">
          </div>
        </li>
        <li class="list-item">
          <div class="item-left">
            <p class="left-text">&nbsp;&nbsp;qq客服</p>
          </div>
          <div class="item-right">
            <p class="right-text">3226635630</p>
            <img v-if="false" src="../../assets/img/login-img/1-注册-下一步ic@2x.png" alt="" class="more-icon">
          </div>
        </li>
        <li class="list-item">
          <div class="item-left">
            <p class="left-text">&nbsp;&nbsp;qq邮箱</p>
          </div>
          <div class="item-right">
            <p class="right-text">3226635630@qq.com</p>
            <img v-if="false" src="../../assets/img/login-img/1-注册-下一步ic@2x.png" alt="" class="more-icon">
          </div>
        </li>
        <li class="list-item">
          <div class="item-left">
            <p class="left-text">&nbsp;&nbsp;手机</p>
          </div>
          <div class="item-right">
            <!-- <p class="right-text">020-38473593</p> -->
            <p class="right-text">17199925307</p>
            <img v-if="false" src="../../assets/img/login-img/1-注册-下一步ic@2x.png" alt="" class="more-icon">
          </div>
        </li>
        <li class="list-item" @click="goRouter('SdGetInvoice')">
          <div class="item-left">
            <p class="left-text">&nbsp;&nbsp;开具发票</p>
          </div>
          <div class="item-right">
            <!-- <p class="right-text">020-38473593</p> -->
            <img  src="../../assets/img/login-img/1-注册-下一步ic@2x.png" alt="" class="more-icon">
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goBack () {
      if (this.$route.query.from) {
        this.$router.push(this.$route.query.from)
      } else {
        this.$router.back(-1)
      }
    },
    goRouter (val) {
      this.$router.push(val)
    }
  }
}
</script>

<style lang="postcss">
#sd-concat-us {
  height: 100%;
  background-color: #fffffd;
  width: 100%;
  & .top-title {
    width: 100%;
    padding: 27px 0;
    top: 0;
    position: fixed;
    width: 100%;
    z-index: 999;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #fffffd;
    background-color: #fffffd;
    box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
    & .back-icon {
      width: 17px;
      height: 34px;
      position: absolute;
      left: 30px;
    }
    & .title-text {
      font-size: 34px;
      font-family: "SourceHanSansCN Medium";
      font-weight: 400;
    }
  }
  & .content-box {
    width: 100%;
    margin-top: 88px;
    padding: 0 30px;
    box-sizing: border-box;
    display: inline-block;
    /* padding-bottom: 100px; */
    & .concat-logo {
      position: relative;
      margin-top: 30px;
      display: flex;
      justify-content: center;
      /* border-bottom: 1px solid #d7d7d7; */
      & .logo-img {
      height: 114px;
      width: 204px;
      }
    }
    & .concat-list {
      & .list-item {
        height: 110px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #d7d7d7;
        & .item-left {
          color: #666;
          font-size: 32px;
        }
        & .item-right {
          display: flex;
          align-items: center;
          color: #333;
          font-size: 32px;
          & .more-icon {
            width: 15px;
            margin-left: 30px;
          }
        }
      }
      /* & .list-flag {
        border: none;
      } */
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shenduUserInfo/SdConcatUs.vue